<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="10.5" stroke="#000"/>
  <path fill="#000" fill-rule="evenodd" d="M4.825 19.443l-.496.433-.658-.752 3.717-3.253a1.5 1.5 0 01.988-.371h7.248a1.5 1.5 0 01.988.371l3.717 3.253-.658.752-.484-.423.436.479A10.963 10.963 0 0112 23a10.963 10.963 0 01-7.62-3.068l.444-.49z" clip-rule="evenodd"/>
  <circle cx="12" cy="10.5" r="3.5" fill="#000"/>
</svg>
